<template>
  <div id="app">
    <RiddleGame />
  </div>
</template>

<script>
import RiddleGame from './components/RiddleGame.vue'

export default {
  name: 'App',
  components: {
    RiddleGame
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  min-height: 100vh;
  background: #f5f7fa;
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
}
</style>
